import { load } from "../../../../pages/player/_id_/_page.server.js";
import "path";
async function GET(event) {
  const payloadtosend = await load(event);
  return new Response(
    JSON.stringify(
      event.params.node && event.params.node !== "" ? payloadtosend[event.params.node] ?? {
        error: "Node does not exist"
      } : payloadtosend
    )
  );
}
export {
  GET
};
